/* eslint-disable import/prefer-default-export */
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';

export const getIsDefaultFilterItem = (val, dateVal) => {
  if (!isEmpty(dateVal)) {
    return false;
  }
  return !val || isEmpty(val) || (isArray(val) && val.length === 0);
};
export const getIsDefaultFilterItems = (items) => {
  let isDefault = true;

  (items || []).map((item) => {
    if ('defaultDate' in item.dropdown) {
      if (!getIsDefaultFilterItem(item.dropdown?.defaultDate)) {
        isDefault = false;
      }
    }
    if (!getIsDefaultFilterItem(item.dropdown?.defaultChecks)) {
      isDefault = false;
    }
  });
  return isDefault;
};
